export const NEWS_HERO_FEATURED_COUNT = 4
/** Grid page size — must be a multiple of 3 (desktop columns). */
export const NEWS_GRID_PAGE_SIZE = 9
/** First fetch only: hero (4) + first grid page (9). Subsequent pages use NEWS_GRID_PAGE_SIZE. */
export const NEWS_LIST_FETCH_SIZE =
  NEWS_HERO_FEATURED_COUNT + NEWS_GRID_PAGE_SIZE
